import Sidebar from "../components/Sidebar";
import React, {useEffect} from "react";
import ConfigureButton from "../components/ConfigureButton";
import {privateApiLongTimeout} from "../api";
import DeleteConfigurationButton from "../components/DeleteConfigurationButton";
import {toast} from "react-toastify";
import axios from "axios";
import WhatsAppLoginQrCode from "../components/WhatsAppLoginQrCode";
import RefreshButton from "../components/RefreshButton";
import DeleteButton from "../components/DeleteButton";

function Services() {
    localStorage.setItem("focus", "servizi connessi")
    const [whatsappServiceStatus, setWhatsappServiceStatus] = React.useState<boolean>()
    const [whatsappServiceStatusLoading, setWhatsappServiceStatusLoading] = React.useState<boolean>(true)

    const [addWhatsappConfigurationStarted, setAddWhatsappConfigurationStarted] = React.useState<boolean>(false)

    const [isConfigureWhatsAppModalOpen, setIsConfigureWhatsAppModalOpen] = React.useState<boolean>(false)
    const [isDeleteWhatsAppConfigurationModalOpen, setIsDeleteWhatsAppConfigurationModalOpen] = React.useState<boolean>(false)

    const fetchWhatsappServiceStatus = async () => {
        setWhatsappServiceStatusLoading(true)
        setWhatsappServiceStatus(undefined)
        try {
            await privateApiLongTimeout.get("/cr-whatsapp-selenium-service/whatsapp/status")
            setWhatsappServiceStatus(true)
        } catch (err) {
            if (axios.isAxiosError(err)) {
                setWhatsappServiceStatus(false)
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setWhatsappServiceStatusLoading(false)
        }
    }

    const deleteWhatsappServiceConfiguration = async () => {
        try {
            toast.success("Disconnessione servizio in corso")
            setWhatsappServiceStatus(undefined)
            setWhatsappServiceStatusLoading(true)
            await privateApiLongTimeout.post("/cr-whatsapp-selenium-service/whatsapp/logout")
            toast.success("Configurazione eliminata con successo")
            setWhatsappServiceStatus(false)
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setWhatsappServiceStatusLoading(false)
        }
    }

    const addWhatsappServiceConfiguration = async () => {
        try {
            toast.success("Procedura di configurazione avviata")
            setAddWhatsappConfigurationStarted(true)
            await privateApiLongTimeout.post("/cr-whatsapp-selenium-service/whatsapp/login")
            setAddWhatsappConfigurationStarted(false)
            toast.success("Configurazione completata con successo")
            setWhatsappServiceStatus(true)
        } catch (err) {
            if (axios.isAxiosError(err)) {
                console.log(err)
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setAddWhatsappConfigurationStarted(false)
        }
    }

    useEffect(() => {
        fetchWhatsappServiceStatus();
    }, []);
    return (
        <>
            <Sidebar/>
            <main className="ml-64 p-6">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-2xl font-bold">Servizi Connessi</h1>
                    <div className="flex items-center gap-2">
                        <RefreshButton onClick={() => {
                            setWhatsappServiceStatus(undefined)
                            setAddWhatsappConfigurationStarted(false)
                            fetchWhatsappServiceStatus()
                        }}/>
                    </div>
                </div>

                <div className="mb-6 bg-white p-4 rounded-xl shadow">
                    <div className="flex items-center justify-between">
                        <h2 className="font-semibold">WhatsApp</h2>
                        <div className="flex justify-end gap-2">
                            {(!whatsappServiceStatus && !whatsappServiceStatusLoading) &&
                                (<ConfigureButton onClick={() => {
                                    setIsConfigureWhatsAppModalOpen(true);
                                }}/>)}
                            {(whatsappServiceStatus && !whatsappServiceStatusLoading) &&
                                (<DeleteConfigurationButton onClick={() => {
                                    setIsDeleteWhatsAppConfigurationModalOpen(true);
                                }}/>)}
                        </div>
                    </div>
                    <label className="block mt-4 text-sm font-medium text-gray-700">Stato</label>
                    <input disabled={true}
                           placeholder={"Nome"}
                           value={whatsappServiceStatusLoading ? "Caricamento..." : whatsappServiceStatus ? "Configurato" : "Non Configurato"}
                           className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                    {addWhatsappConfigurationStarted && (
                        <div className={"flex items-center justify-center mt-4"}>
                            <WhatsAppLoginQrCode/>
                        </div>)}
                </div>

                {isConfigureWhatsAppModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-xl p-6 w-full max-w-md">
                            <div className="w-full p-2 rounded">
                                <span>Prima di continuare assicurati di aver seguito questi passaggi</span>
                            </div>
                            <div className="w-full p-2 rounded">
                                <ul>
                                    <li>• Apri WhatsApp sul tuo cellulare business</li>
                                    <li>• Vai nella sezione per collegare un nuovo dispositivo</li>
                                    <li>• Tieni la schermata per la scansione del QR attiva</li>
                                </ul>
                            </div>
                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    onClick={() => {
                                        setIsConfigureWhatsAppModalOpen(false);
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded"
                                >
                                    Annulla
                                </button>

                                <button
                                    onClick={() => {
                                        setIsConfigureWhatsAppModalOpen(false);
                                        addWhatsappServiceConfiguration()
                                    }}
                                    className="px-4 py-2 bg-blue-900 text-white rounded"
                                >
                                    Continua
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {isDeleteWhatsAppConfigurationModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-xl p-6 w-full max-w-md">
                            <div className="w-full p-2 rounded">
                                <span>Sei sicuro di voler eliminare la configurazione di WhatsApp?</span>
                            </div>
                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    onClick={() => {
                                        setIsDeleteWhatsAppConfigurationModalOpen(false);
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded"
                                >
                                    Annulla
                                </button>

                                <DeleteButton onClick={() => {
                                    setIsDeleteWhatsAppConfigurationModalOpen(false);
                                    deleteWhatsappServiceConfiguration()
                                }}/>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </>
    )
}

export default Services;